import React from 'react'
import {
    RegionItem,
    ImageWrapper,
    Content,
    Title,
    SubTitle,
    IconContainer,
    ArrowRightIcon,
    ContentContainer,
} from '../region-count-section/region-count-styles'
import { useTranslation } from '../../../hooks/locale'
import { RegionDataTransport } from '../../../transports/home-page-transport'
import { getBasePath } from '../../../utils/miscellaneous-utils'

interface Props {
    region: RegionDataTransport
    prefix: string
}

const DEFAULT_REGION_IMAGE = `${getBasePath('/assets/images/region/scenic-location.jpeg')}?imwidth=100`

export const RegionItemCard = React.memo(({ region, prefix }: Props) => {
    const { t } = useTranslation()

    return (
        <RegionItem href={region.url} noCrawl={region.noCrawl}>
            <ImageWrapper>
                <img
                    src={region.image?.url ? `${region.image.url}?imwidth=100` : DEFAULT_REGION_IMAGE}
                    alt={region.title}
                    loading="lazy"
                />
            </ImageWrapper>

            <ContentContainer>
                <Content>
                    <Title>{region.title}</Title>
                    {region.count && (
                        <SubTitle>
                            {region.count} {t('homes')}
                        </SubTitle>
                    )}
                </Content>

                <IconContainer>
                    <ArrowRightIcon />
                </IconContainer>
            </ContentContainer>
        </RegionItem>
    )
})

RegionItemCard.displayName = 'RegionItemCard'
